import { useEffect } from 'react';
import { useMediaDevice } from './hooks';
import LoopPlayback from './LoopPlayback';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { t } = useLang('Oasis.Brands');
    const { locale } = getLocal();

    const { isH5, isPad, isDesktop, isPC } = useMediaDevice();
    const list = [
        'https://websiteoss.ecoflow.com/upload/image/1755163272990/logo_1.png',
        'https://websiteoss.ecoflow.com/upload/image/1755163272136/logo_2.png',
        'https://websiteoss.ecoflow.com/upload/image/1755163271859/logo_3.png',
        'https://websiteoss.ecoflow.com/upload/image/1755163273236/logo_4.png',
        'https://websiteoss.ecoflow.com/upload/image/1755163272708/logo_5.png',
        'https://websiteoss.ecoflow.com/upload/image/1755163271665/logo_6.png',
        'https://websiteoss.ecoflow.com/upload/image/1755163272432/logo_7.png',
    ];

    useEffect(() => {
        const brands = document.querySelector('#Brands') as HTMLVideoElement;
        if (isH5) {
            brands.style.opacity = '1';
            return;
        }

        const ani = AniContainer.create({
            triggerElement: '#Brands',
            triggerHook: 1,
            offset: 0,
            duration: '200%',
            // asyncFromTo: [
            //     [brands, { opacity: 0 }, { opacity: 0 }, 0.1],
            //     [brands, { opacity: 0 }, { opacity: 1 }, 0.1],
            //     [brands, { opacity: 1 }, { opacity: 0 }, 0.1],
            //     [brands, { opacity: 0 }, { opacity: 0 }, 0.1],
            // ],
            asyncFromTo: [
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
            ],
            asyncTimeLine: [0, 0.1, 0.5, 1],
        });
        return () => {
            ani.destroy();
        };
    }, [isPad, isH5, isPC]);

    return (
        <div className={`${styles.TheComp}`} id="Brands">
            {/* <div className="brand-title">{t('title')}</div> */}
            {isH5 ? (
                <div>
                    {/* <LoopPlayback list={[list[0], list[1], list[2]]} reverse />
                    {<LoopPlayback list={[list[3], list[4], list[5], list[6]]} />} */}
                    <LoopPlayback list={list} reverse />
                </div>
            ) : (
                <div>
                    <LoopPlayback list={list} />
                    {['us', 'ca'].includes(locale) && <LoopPlayback list={list} reverse />}
                </div>
            )}
        </div>
    );
}
